import React, { useState, useEffect } from 'react';
import customFetch from "./apicall/api";
import { withRouter } from "react-router";
import { useLocation } from 'react-router-dom';
import SubmitButton from './SubmitButton';
import axios from 'axios';
import { ReactFormGenerator } from '@acen-navadhan/react-form-builder';
import { insert_mongopayload, update_mongopayload } from './Services';
import { Select, Modal, Button, Input, DatePicker, message } from "antd";
import { generate_dynamic_id, generateRegexValue } from './Utility';

const FormBuildView = (props) => {
  const { 
    initialFormData = [], 
    fetchDataUrl, 
    embedded = false, 
    payload_data = [], 
    formConfig, 
    payload_config, 
    payload_configTwo,
    getPayloads, 
    closeFormViewModal, 
    setOnFormviewSubmit, 
    setOnFormviewUpdateSubmit, 
    handlePopupMessage, 
    formInbound,
    updateComponentGlobalState } = props;
  const location = useLocation();
  const [formData, setFormData] = useState(initialFormData);
  const [formInputData, setFormInputData] = useState([]);
  const [dropdownOptions, setDropdownOptions] = useState([]);
  const [paramsPayloadData, setParamsPayloaddata] = useState([]);
  const [paramsFormConfig, setParamsFormConfig] = useState([]);
  const [paramsPayloadConfig, setParamsPayloadConfig] = useState([]);
  const [apiResponseModal, setApiResponseModal] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [isspin, setIsspin] = useState(false);
  const [payloadDataForSW, setPayloadDataForSW] = useState([]);
  const [payloadConfigForSW, setPayloadConfigForSW] = useState();
  const [updatedFields, setUpdatedFields] = useState({});
  const [initValForPayloadpath, setInitValForPayloadpath] = useState({});
  const [finalValForPayloadpath, setFinalValForPayloadpath] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [resetKey, setResetKey] = useState(0);
  const [isFileUploading, setIsFileUploading] = useState(false);
  const [componentGlobalState, setComponentGlobalState] = useState(function() {
    if (props && props.componentGlobalState) {
      return props.componentGlobalState;
    } else if (window && window.sharedState && window.sharedState.formConfig) {
      return window.sharedState.formConfig;
    } else {
      return {};
    }
  });
  // const [componentGlobalState, setComponentGlobalState] = useState({});
  const [process_err, setProcessErr] = useState(false);

  const state = window.history.state;
 
  useEffect(() => {
    if (props.componentGlobalState !== undefined && props.componentGlobalState !== null && Object.keys(props.componentGlobalState).length > 0) {
      if (JSON.stringify(props.componentGlobalState) !== JSON.stringify(componentGlobalState)) {
        setComponentGlobalState(props.componentGlobalState);
      }
    }
  }, [props.componentGlobalState]);

  useEffect(() => {
    if (state && state.formConfig && state.formConfig.length) {
      setFormData(applyRequiredToFields(JSON.parse(state.formConfig)))
      setPayloadConfigForSW(JSON.parse(state.payload_config))
      state.payload_data.length && setPayloadDataForSW([JSON.parse(state.payload_data)])
    }
  }, [state])

  // Log payload_configTwo from props (when used in Modal)
  useEffect(() => {
    console.log("payload_configTwo from props", payload_configTwo);
  }, [payload_configTwo])

  // Log payload_config from props
  useEffect(() => {
    console.log("payload_config from props", payload_config);
  }, [payload_config])
  
  useEffect(() => {
    console.log("formConfig", formConfig)
    document.title = "FormBuildView";
    if (!window.sharedState && formConfig) {
      let temp = [];
      console.log(JSON.stringify(formInbound, null, 2))

      if(formInbound && formInbound.length > 0) {
        formConfig.map((item) => {
          let flag = 0;
          formInbound.map((item2) => {
            if(item.payloadpath === item2.destination) {
              flag = 1;
              temp.push({
                ...item,
                inboundConfig: item2.source
              })
            }
          })
          if(flag === 0) {
            temp.push(item)
          }
        })
      } else {
        const hasInboundConfig = formConfig.some(item => item.inboundConfig);
        if (hasInboundConfig) {
          temp = formConfig;
        } else {
          temp = formConfig;
        }
      }
      if(temp.length > 0) {
        const requiredFields = applyRequiredToFields(temp);
        setFormData(requiredFields);
        fetchDropdownData(requiredFields, localStorage.getItem("api_token"));
      } else {
        const requiredFields = applyRequiredToFields(formConfig);
        setFormData(requiredFields);
        fetchDropdownData(requiredFields, localStorage.getItem("api_token"));
      }
    }
  }, []);
  
  useEffect(() => {
    const sharedState = window.sharedState;
    if (sharedState && sharedState.formConfig) {
      try {
        const formConfigData = JSON.parse(sharedState.formConfig);

        let processedFormData = formConfigData;

        // Check if we need to merge formInbound data
        if (sharedState.formInbound && sharedState.formInbound.length > 0) {
          let temp = [];
          formConfigData.map((item) => {
            let flag = 0;
            sharedState.formInbound.map((item2) => {
              if(item.payloadpath === item2.destination) {
                flag = 1;
                temp.push({
                  ...item,
                  inboundConfig: item2.source
                })
              }
            })
            if(flag === 0) {
              temp.push(item)
            }
          })
          processedFormData = temp;
        } else {
          const hasInboundConfig = formConfigData.some(item => item.inboundConfig);
        }

        const requiredFields = applyRequiredToFields(processedFormData);
        setFormData(requiredFields);
        fetchDropdownData(requiredFields, localStorage.getItem("api_token"));

        if (sharedState.payload_data && sharedState.payload_data.length) {
          setParamsPayloaddata([JSON.parse(sharedState.payload_data)]);
        }
        setParamsFormConfig(processedFormData);
        setParamsPayloadConfig(JSON.parse(sharedState.payload_config));

        if (sharedState.api_token) {
          localStorage.setItem('api_token', sharedState.api_token);
        }
      } catch (error) {
        console.error("Error parsing formConfig or payload_data:", error);
      }
    }
  }, []);
  // getDataFronresponse Function
  const getDataFronresponse = (data) => {
    const result = [];

    // Iterate over all keys in the data object
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        result.push({ key: key, value: data[key] });
      }
    }

    return result;
  };

  const transformApiData = (apiResponse, getoutputdata) => {

    const keyRegex = /{{(.*?)}}/g;
    const keys = [];
    let match;

    // Extract keys from the output data template
    while ((match = keyRegex.exec(getoutputdata)) !== null) {
      keys.push(match[1]);
    }


    // Transform the API response
    const transformedData = apiResponse.map((item) => {
      const option = {};

      keys.forEach((key, index) => {
        const keyParts = key.split('.');
        let value = item;

        for (let i = 0; i < keyParts.length; i++) {
          const part = keyParts[i];
          if (value && value[part] !== undefined) {
            value = value[part];
          } else {
            value = undefined;
            break;
          }
        }
        // Ensure the `value` is numeric if possible
        if (index === 1 && typeof value === "string" && !isNaN(value)) {
          value = Number(value);
        }

        if (index === 0) {
          option.text = value || ''; // Use the first key for the dropdown text
        } else if (index === 1) {
          option.value = value !== undefined ? value : ''; // Use the second key for the dropdown value
        }
      });

      return option;
    });

    return transformedData;
  };

  const fetchDropdownData = async (fields, token) => {
    for (const field of fields) {
        if (field.selectedApiUrl && field.selectedApiUrl.api_url) {
            try {
                // Check and process query parameters in the API URL
                const processedUrl = field.selectedApiUrl.api_url.replace(/{{(.*?)}}/g, (_, key) => {
                    const trimmedKey = key.trim();
                    const queryParam = this.getValue(field.payload, trimmedKey); // Assume `field.payload` holds the relevant data

                    // Handle special predefined keys
                    if (trimmedKey === "user_id") {
                        return localStorage.getItem("in_userid");
                    }
                    if (trimmedKey === "branch_id") {
                        return localStorage.getItem("branch_id");
                    }
                    if (
                        trimmedKey === "effective_designation_id" ||
                        trimmedKey === "effective_designation"
                    ) {
                        return localStorage.getItem("e_designation_id");
                    }

                    // Handle object-based query parameters
                    if (typeof queryParam === "object" && queryParam !== null) {
                        return Object.entries(queryParam)
                            .map(
                                ([key, value]) =>
                                    `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
                            )
                            .join("&");
                    } else {
                        // Handle scalar values
                        return encodeURIComponent(queryParam || "");
                    }
                });

                const url = process.env.REACT_APP_URL + field.selectedApiUrl.api_url;
                let response = await customFetch(url, {
                    method: "GET",
                    headers: { "api-token": token },
                });
                response = await response.json();

                const path = field.selectedApiUrl.output_path.split(".");
                const res_path = path ? path.reduce((acc, curr) => acc[curr], response) : response;

                if (res_path.length > 0) {
                    const transformedData = transformApiData(
                        res_path,
                        field.selectedApiUrl.getoutputdata
                    );

                    const options = transformedData.map((item, index) => ({
                        value: item.value,
                        text: item.text,
                        key: `dropdown_option_${index}_${Math.random().toString(36).substr(2, 9)}`,
                    }));

                    field.options = options;
                    setDropdownOptions((prev) => [...prev, ...options]);
                }
            } catch (error) {
                console.error("Error fetching dropdown data: ", error);
            }
        } else {
          if(field.inboundConfig && field.inboundConfig.addapi === "1") {
            try {
              const apiurl = payload_config.get_api_mapping.filter((item) => item.action_name === field.inboundConfig.selectapi)
              // Check and process query parameters in the API URL
              const processedUrl = apiurl[0].api_url.replace(/{{(.*?)}}/g, (_, key) => {
                  const trimmedKey = key.trim();
                  const queryParam = this.getValue(field.payload, trimmedKey); // Assume `field.payload` holds the relevant data

                  // Handle special predefined keys
                  if (trimmedKey === "user_id") {
                      return localStorage.getItem("in_userid");
                  }
                  if (trimmedKey === "branch_id") {
                      return localStorage.getItem("branch_id");
                  }
                  if (
                      trimmedKey === "effective_designation_id" ||
                      trimmedKey === "effective_designation"
                  ) {
                      return localStorage.getItem("e_designation_id");
                  }

                  // Handle object-based query parameters
                  if (typeof queryParam === "object" && queryParam !== null) {
                      return Object.entries(queryParam)
                          .map(
                              ([key, value]) =>
                                  `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
                          )
                          .join("&");
                  } else {
                      // Handle scalar values
                      return encodeURIComponent(queryParam || "");
                  }
              });

              const url = process.env.REACT_APP_URL + apiurl[0].api_url;
              let response = await customFetch(url, {
                  method: "GET",
                  headers: { "api-token": token },
              });
              response = await response.json();

              const path = apiurl[0].output_path.split(".");
              const res_path = path ? path.reduce((acc, curr) => acc[curr], response) : response;

              if (res_path.length > 0) {
                  const transformedData = transformApiData(
                      res_path,
                      apiurl[0].getoutputdata
                  );

                  const options = transformedData.map((item, index) => ({
                      value: item.value,
                      text: item.text,
                      key: `dropdown_option_${index}_${Math.random().toString(36).substr(2, 9)}`,
                  }));

                  field.options = options;
                  setDropdownOptions((prev) => [...prev, ...options]);
              }
          } catch (error) {
              console.error("Error fetching dropdown data: ", error);
          }
          }
        }
    }
    setFormData(applyRequiredToFields([...fields]));
  };

  const checkifalert = (field) => {
    if (field && field.inboundConfig && field.inboundConfig.alert_condition && Array.isArray(field.inboundConfig.alert_condition)) {
      for (let alertRule of field.inboundConfig.alert_condition) {
        const { conditions, alert_message, message_type } = alertRule;

        let allConditionsPassed = true;

        for (let i = 0; i < conditions.length; i += 2) {
          const cond1 = conditions[i];
          const cond2 = conditions[i + 1];

          // Defensive: skip if pair is incomplete
          if (!cond1 || !cond2) {
            allConditionsPassed = false;
            break;
          }

          // Get raw values
          let raw1 = cond1.manual_condition === "yes"
            ? cond1.condition_field
            : componentGlobalState[cond1.condition_field];

          let raw2 = cond2.manual_condition === "yes"
            ? cond2.condition_field
            : componentGlobalState[cond2.condition_field];

          // Fallbacks
          raw1 = raw1 !== undefined && raw1 !== null ? raw1 : "";
          raw2 = raw2 !== undefined && raw2 !== null ? raw2 : "";

          // Detect if numeric
          const isNumeric1 = !isNaN(parseFloat(raw1));
          const isNumeric2 = !isNaN(parseFloat(raw2));

          // Prepare values for comparison
          const val1 = isNumeric1 ? parseFloat(raw1) : String(raw1);
          const val2 = isNumeric2 ? parseFloat(raw2) : String(raw2);

          // Perform the comparison
          let isMet = false;
          switch (cond1.conditional_operator) {
            case ">":
              isMet = isNumeric1 && isNumeric2 && val1 > val2;
              break;
            case "<":
              isMet = isNumeric1 && isNumeric2 && val1 < val2;
              break;
            case ">=":
              isMet = isNumeric1 && isNumeric2 && val1 >= val2;
              break;
            case "<=":
              isMet = isNumeric1 && isNumeric2 && val1 <= val2;
              break;
            case "==":
              isMet = val1 == val2; // loosely equal for both numbers and strings
              break;
            case "!=":
              isMet = val1 != val2;
              break;
            default:
              isMet = false;
          }

          // If one condition pair fails, stop checking
          if (!isMet) {
            allConditionsPassed = false;
            break;
          }
        }

        if (allConditionsPassed) {
          const messageText = getDataBetweenBraces(alert_message);

          if (message_type === "err" || message_type === "error") {
            setProcessErr(true);
            message.error(messageText);
          } else {
            setProcessErr(false);
            message.warning(messageText);
          }

          return; // Stop after first matched alert
        } else {
          setProcessErr(false)
        }
      }
    }
  };

  const getDataBetweenBraces = (template, data, manual_input = "") => {
    if (template) {
      return template.replace(/{{(.*?)}}/g, (_, key) => {
        const trimmedKey = key.trim();
        if (trimmedKey === "user_id") {
          return localStorage.getItem("in_userid");
        }
        if (trimmedKey === "branch_id") {
          return localStorage.getItem("branch_id");
        }
        if (
          trimmedKey === "effective_designation_id" ||
          trimmedKey === "effective_designation"
        ) {
          return localStorage.getItem("e_designation_id");
        }
        if (
          manual_input != "" && (trimmedKey === "INPUT" ||
            trimmedKey === "input")
        ) {
          return manual_input;
        }
        if (componentGlobalState && componentGlobalState.hasOwnProperty(trimmedKey) && componentGlobalState[trimmedKey] != null) {
          return componentGlobalState[trimmedKey];
        }
        if (data) {
          //return this.getValue(data, trimmedKey);
          const queryParam = getValue(data, trimmedKey);

          // Check if queryParam is an object
          if (typeof queryParam === "object" && queryParam !== null) {
            // If the query parameter is an object, convert it to a query string
            return Object.entries(queryParam)
              .map(
                ([key, value]) =>
                  `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
              )
              .join("&");
          } else {
            // If not an object, return the value as-is
            return encodeURIComponent(queryParam);
          }
        }
      });
    }
  };

  const getValue = (data, path) => {
    const keys = path.split(/[.:]/);
    let value = data;
    for (const key of keys) {
      if (value === undefined || value === null) {
        return ""; // Return empty string if value is undefined or null
      }
      // Check if key contains array notation, e.g., "cash_transfer_log[0]"
      if (key.includes("[")) {
        const [arrayKey, index] = key.split(/[[\]]/).filter(Boolean);
        value = value[arrayKey];
        if (!value) return ""; // Early return if array key is not found
        value = value[Number(index)];
      } else {
        value = value[key];
      }
    }
    return value !== undefined ? value : "";
  };

  const applyRequiredToFields = (fields) => {
    if (!Array.isArray(fields)) return fields;
    return fields.map((field) => {
      const isRequiredFormview =
        String(field.isRequiredFormview) === "1" ||
        (field.inboundConfig && String(field.inboundConfig.isRequiredFormview) === "1");
      
      // Check if isRequiredFormview is explicitly set to 0 (not required in form view)
      const isRequiredFormviewExplicitlyFalse =
        String(field.isRequiredFormview) === "0" ||
        (field.inboundConfig && String(field.inboundConfig.isRequiredFormview) === "0");
      
      // Determine final required status
      let isRequired;
      if (isRequiredFormviewExplicitlyFalse) {
        // If isRequiredFormview is explicitly 0, field is not required in form view
        isRequired = false;
      } else if (isRequiredFormview) {
        // If isRequiredFormview is 1, field is required
        isRequired = true;
      } else {
        // Fallback: check for upload requirements for backward compatibility
        isRequired =
          String(field.UploadRequired) === "1" ||
          (field.fileupload && field.fileupload[0] && String(field.fileupload[0].UploadRequired) === "1") ||
          (field.inboundConfig && field.inboundConfig.fileupload && field.inboundConfig.fileupload[0] && String(field.inboundConfig.fileupload[0].UploadRequired) === "1");
      }
      
      return {
        ...field,
        required: isRequired,
      };
    });
  };

  const isFileUploadField = (field) => {
    return ["FileUpload", "Camera", "Image", "Download"].includes(field.element) ||
      field.datatype === "Downloadfile" ||
      Boolean(field.fileupload && field.fileupload.length) ||
      Boolean(field.inboundConfig && field.inboundConfig.fileupload && field.inboundConfig.fileupload.length);
  };

  const findMatchingInput = (field) => {
    if (!Array.isArray(formInputData)) return undefined;

    const searchKeys = [field.id, field.field_name, field.name, field.payloadpath, field.label]
      .filter((key) => key !== undefined && key !== null)
      .map((value) => value.toString());

    const inputCandidates = formInputData.map((input) => ({
      input,
      keys: [input.id, input.name, input.field_name, input.payloadpath, input.label]
        .filter((key) => key !== undefined && key !== null)
        .map((value) => value.toString()),
    }));

    const exactMatch = inputCandidates.find(({ keys }) =>
      keys.some((inputKey) => searchKeys.includes(inputKey))
    );
    if (exactMatch) return exactMatch.input;

    const label = field.label ? field.label.toString().toLowerCase() : "";
    const labelMatch = inputCandidates.find(({ input }) => {
      const inputKeys = [input.id, input.name, input.field_name, input.payloadpath, input.label]
        .filter((key) => key !== undefined && key !== null)
        .map((value) => value.toString().toLowerCase());
      return inputKeys.some((inputKey) => inputKey === label || inputKey.includes(label) || label.includes(inputKey));
    });
    return labelMatch ? labelMatch.input : undefined;
  };

  const extractFileObjects = (value) => {
    if (value === undefined || value === null) return [];
    if (value instanceof File) return [value];
    if (typeof FileList !== 'undefined' && value instanceof FileList) return Array.from(value);
    if (Array.isArray(value)) {
      return value.flatMap((item) => extractFileObjects(item));
    }
    if (typeof value === 'object') {
      if (Array.isArray(value.filelistdata)) {
        return value.filelistdata.flatMap((item) => extractFileObjects(item));
      }
      return Object.values(value).flatMap((item) => extractFileObjects(item));
    }
    return [];
  };

  const hasFileUploadValue = (value) => {
    if (value === undefined || value === null) return false;
    if (typeof value === 'string') return value.trim().length > 0;
    if (value instanceof File) return true;
    if (typeof FileList !== 'undefined' && value instanceof FileList) return value.length > 0;
    if (Array.isArray(value)) {
      return value.some((item) => hasFileUploadValue(item));
    }
    if (typeof value === 'object') {
      if (Array.isArray(value.filelistdata)) {
        return value.filelistdata.some((item) => hasFileUploadValue(item));
      }
      return Object.values(value).some((item) => hasFileUploadValue(item));
    }
    return false;
  };

  const getFileInputFilesFromDOM = (field) => {
    if (!field || !field.field_name || typeof document === 'undefined') return [];
    const selector = `input[type="file"][name^="${field.field_name}"]`;
    const inputs = Array.from(document.querySelectorAll(selector));
    const files = [];
    inputs.forEach((input) => {
      if (input.files && input.files.length > 0) {
        files.push(...Array.from(input.files));
      }
    });
    return files;
  };

  const getPayloadValueForField = (field) => {
    const payloadSource =
      (paramsPayloadData && paramsPayloadData[0]) ||
      (payloadDataForSW && payloadDataForSW[0]) ||
      (Array.isArray(payload_data) && payload_data[0]);

    if (!payloadSource || !field.payloadpath) return undefined;
    return getValue(payloadSource, field.payloadpath);
  };

  const validateRequiredFields = () => {
    const errors = [];

    formData.forEach((field) => {
      if (!field.required) return;

      const fieldLabel = field.label || field.field_name || field.name || field.payloadpath || 'required field';
      const matchingInput = findMatchingInput(field);
      const rawValue = matchingInput ? matchingInput.value : getPayloadValueForField(field);

      if (isFileUploadField(field)) {
        const fileValue = matchingInput ? matchingInput.value : rawValue;
        const domFiles = getFileInputFilesFromDOM(field);
        const extractedFiles = extractFileObjects(fileValue);
        const hasValue = hasFileUploadValue(fileValue) || extractedFiles.length > 0 || domFiles.length > 0;
        if (!hasValue) {
          errors.push(`Please upload a file for "${fieldLabel}" before submitting.`);
        }
      } else {
        const isEmptyValue =
          rawValue === undefined ||
          rawValue === null ||
          (typeof rawValue === 'string' && rawValue.trim() === '') ||
          (Array.isArray(rawValue) && rawValue.length === 0);
        if (isEmptyValue) {
          errors.push(`Please fill the required field "${fieldLabel}" before submitting.`);
        }
      }
    });

    return errors;
  };

  const handleInputChange = (data) => {
    const updatedData = data.map((item) => {
      const field = formData.find((f) => f.id === item.id);
      if (field && field.options) {
        if (Array.isArray(item.value)) {
          item.value = item.value.map((key) => key);
        } else {
          item.value = item.value;
        }
      }
      return item;
    });
  
    if (
      (payload_data.length && payload_data[0]._id && payload_data[0]._id.$oid) ||
      (paramsPayloadData[0] && paramsPayloadData[0]._id && paramsPayloadData[0]._id.$oid) ||
      (payloadDataForSW[0] && payloadDataForSW[0]._id && payloadDataForSW[0]._id.$oid)
    ) {
      const initialData = paramsPayloadData.length
        ? paramsPayloadData
        : payloadDataForSW.length
        ? payloadDataForSW
        : Array.isArray(payload_data)
        ? payload_data
        : [payload_data];
  
      const result = {};
      formData.forEach((item) => {
        let value = initialData[0];
        if (item.payloadpath) {
          const keys = item.payloadpath.split('.');
  
          keys.forEach((key) => {
            value = value[key];
          });
        }
        result[item.field_name] = value;
        setInitValForPayloadpath(result);
      });
  
      let response = updatedData.filter(
        (item) =>
          initValForPayloadpath.hasOwnProperty(item.name) &&
          initValForPayloadpath[item.name] != item.value &&
          (Array.isArray(initValForPayloadpath[item.name])
            ? JSON.stringify(initValForPayloadpath[item.name]) !== JSON.stringify(item.value)
            : true)
      );
  
      response = response.filter(
        (item) => item.value !== null || (typeof item.value === 'string' && item.value.length !== 0)
      );
  
      const finalUpdatedvaluewithPayloadpath = {};
      response.forEach((item) => {
        finalUpdatedvaluewithPayloadpath[findPayloadPath(item.name)] = item.value;
      });
  
      setFinalValForPayloadpath(finalUpdatedvaluewithPayloadpath);
    }
    if (JSON.stringify(updatedData) !== JSON.stringify(formInputData)) {
      setFormInputData(Array.isArray(updatedData) ? updatedData : []);

      const changedFields = {};
      updatedData.forEach((item) => {
        const original = formInputData.find((originalItem) => originalItem.id === item.id);
        if (!original || JSON.stringify(original.value) !== JSON.stringify(item.value)) {
          changedFields[item.name] = item.value;
          const field = formData.find((data) => data.id === item.id)
          updateComponentGlobalState({ [field.payloadpath]: item.value }, () => console.warn("data-->upd", componentGlobalState))
        }
      });
        setUpdatedFields((prevFields) => ({ ...prevFields, ...changedFields }));
    }
  };

  const findPayloadPath = (name) => {
    const field = formData.find(item => item.field_name === name || item.id === name);
    return field ? field.payloadpath : undefined;
  };

  const transformDataStructure = (processedData) => {
    const result = {};
    processedData.forEach(item => {
      if (item.payload_path && item.value !== undefined) {
        const pathParts = item.payload_path.split('.');
        let currentLevel = result;

        for (let i = 0; i < pathParts.length; i++) {
          const part = pathParts[i];
          if (i === pathParts.length - 1) {
            currentLevel[part] = item.value;
          } else {
            if (!currentLevel[part]) currentLevel[part] = {};
            currentLevel = currentLevel[part];
          }
        }
      }
    });
    return result;
  };

  // Convert product_id and petty_flag to integers recursively
  const convertFieldsToInt = (obj) => {
    Object.keys(obj).forEach(key => {
      if (key === 'product_id' || key === 'petty_flag') {
        const numValue = parseInt(obj[key], 10);
        if (!isNaN(numValue)) {
          obj[key] = numValue;
          console.log(`Converted ${key} to integer: ${obj[key]}`);
        }
      } else if (typeof obj[key] === 'object' && obj[key] !== null && !Array.isArray(obj[key])) {
        convertFieldsToInt(obj[key]);
      }
    });
  };

  const handleSave = async () => {
    setIsSubmitting(true);
    console.log('formData', formData);
    console.log('formInputData', formInputData);
    
    if (!payload_configTwo) {
      console.error("ERROR: payload_configTwo is undefined!");
      return;
    }
    
    if (!payload_configTwo.db_name) {
      console.error("ERROR: payload_configTwo.db_name is undefined!");
      return;
    }

    const requiredFieldErrors = validateRequiredFields();
    if (requiredFieldErrors.length > 0) {
      requiredFieldErrors.forEach((errorMessage) => {
        message.error(errorMessage);
      });
      setIsSubmitting(false);
      return;
    }
    
    if (!payload_configTwo.collection_name) {
      console.error("ERROR: payload_configTwo.collection_name is undefined!");
      return;
    }
    
    if (!payload_configTwo.collection_name) {
      console.error("ERROR: payload_configTwo.collection_name is undefined!");
      return;
    }

    let doc_group;
    let doc_type;
    const results = [];
    formData.forEach(item1 => {
      const match = formInputData.find(item2 => item2.id === item1.id);
      if (match && item1.options) {
        const matchingOptions = item1.options.filter(option => match.value.includes(option.key));
        matchingOptions.forEach(option =>
          results.push({ payload_path: item1.payloadpath, value: option.value })
        );
      }
    });

    formData.forEach(item => {
      if(item.inboundConfig) {
        doc_group = item.inboundConfig.doc_group
      }
    });


    if (Array.isArray(formInputData)) {
      const processedData = formInputData.map((item) => {
        let value = item.value;
        const payloadPath = findPayloadPath(item.name);

        if (typeof value === "string") {
          if (item.name.startsWith("number_input") || item.name.startsWith("phone_input")) {
            value = value !== "" ? Number(value) : null;
          } else if (item.name.startsWith("date_picker")) {
            value = value ? new Date(value) : null;
          }
        }

        return {
          name: item.name,
          value: value,
          payload_path: payloadPath || "",
        };
      });
      console.log("Processed Data:", processedData);
      const api_token = localStorage.getItem('api_token');

      if (!api_token) {
        console.error('API token is missing from localStorage.');
        return;
      }

      const uploadedFiles = [];
      const doc_types = [];
      
      formData.forEach((field) => {
        if (["FileUpload", "Camera", "Image", "Download"].includes(field.element)) {
          const matchingInput = findMatchingInput(field);

          if (matchingInput) {
            console.log(`Input value structure for field ${field.id}:`, matchingInput.value);
          }

          let files = matchingInput ? extractFileObjects(matchingInput.value) : [];
          if (files.length === 0) {
            files = getFileInputFilesFromDOM(field);
          }
          console.log(`Extracted files for field ${field.id}:`, files);

          if (files.length > 0) {
            const numericDocType = uploadedFiles.length + 1;
            doc_types.push(numericDocType);
            console.log(`Numeric doc_type assigned:`, numericDocType);

            const fileUploadEntry = {
              files,
              uploadPath: (field.inboundConfig && field.inboundConfig.fileupload && field.inboundConfig.fileupload[0] && field.inboundConfig.fileupload[0].UploadPath) || field.filePath || '',
              formInputId: field.id,
              numericDocType: numericDocType
            };

            uploadedFiles.push(fileUploadEntry);
          }
        }
      });

      console.log("Uploaded files array:", uploadedFiles);

      if (uploadedFiles.length) {
        try {
          const formDataForUpload = new FormData();

          const remotePaths = formData
            .filter((item) => {
              const uploadPath = (item.inboundConfig && item.inboundConfig.fileupload && item.inboundConfig.fileupload[0] && item.inboundConfig.fileupload[0].UploadPath) || item.filePath;
              return uploadPath && uploadPath.trim() !== "";
            })
            .map((item) => (item.inboundConfig && item.inboundConfig.fileupload && item.inboundConfig.fileupload[0] && item.inboundConfig.fileupload[0].UploadPath) || item.filePath)
            .join(",");
          
          console.log("Remote paths:", remotePaths);

          const payloadDataForUpload = paramsPayloadData.length
            ? paramsPayloadData[0]
            : payloadDataForSW.length
            ? payloadDataForSW[0]
            : Array.isArray(payload_data) && payload_data.length
            ? payload_data[0]
            : null;

          uploadedFiles.forEach((fileGroup) => {
            fileGroup.files.forEach((file, index) => {
              // Find the corresponding field to get inboundConfig
              const field = formData.find(f => f.id === fileGroup.formInputId);
              const uploadName = (field && field.inboundConfig && field.inboundConfig.fileupload && field.inboundConfig.fileupload[0] && field.inboundConfig.fileupload[0].UploadName) || '';
              let filename = file.name;
              if (uploadName) {
                const fileExtension = file.name.split(/[.:]/).pop();
                const originalFileNameWithoutExt = file.name.replace(/\.[^/.]+$/, "");
                const uploadTemplate = uploadName;

                const replacedName = uploadTemplate.replace(/{{(.*?)}}/g, (_, key) => {
                  const trimmedKey = key.trim();

                  if (trimmedKey.startsWith("random:")) {
                    const regexPattern = trimmedKey.replace("random:", "");
                    return generateRegexValue(regexPattern) || "";
                  }

                  switch (trimmedKey) {
                    case "user_id":
                      return localStorage.getItem("in_userid") || "";
                    case "branch_id":
                      return localStorage.getItem("branch_id") || "";
                    case "effective_designation_id":
                    case "effective_designation":
                      return localStorage.getItem("e_designation_id") || "";
                    case "unix":
                    case "updated_at":
                      return Math.floor(Date.now() / 1000);
                    case "filename":
                      return originalFileNameWithoutExt;
                    default: {
                      const value = payloadDataForUpload ? getValue(payloadDataForUpload, trimmedKey) : "";
                      return value !== undefined && value !== null ? value : "";
                    }
                  }
                });

                filename = `${replacedName}.${fileExtension}`;
              }
              formDataForUpload.append("file", file, filename);
            });
          });

          const uploadMetadata = {
            uploaded_by: localStorage.getItem("in_userid") || "unknown_user",
            document_type: doc_types.length > 0 ? doc_types.join(",") : "",
            remote_path: remotePaths || "",
            family_member_id: 0,
            client_id: "collection UI"
          };
          
          Object.entries(uploadMetadata).forEach(([key, value]) => {
            formDataForUpload.append(key, value);
          });
          
          setIsFileUploading(true);
          const response = await customFetch(`${process.env.REACT_APP_URL}/multiple/file/upload`, {
            method: "POST",
            headers: {
              "api-token": api_token,
            },
            body: formDataForUpload,
          });

          if (!response.ok) {
            const errorText = await response.text();
            console.error("Upload error response:", errorText);
            throw new Error(`Upload failed with status: ${response.status} ${response.statusText}`);
          }

          const uploadResponse = await response.json();
          if (!Array.isArray(uploadResponse)) {
            console.error("Upload response is not an array:", uploadResponse);
            throw new Error("Upload response is not an array. Check API response structure.");
          }
          console.log("Upload response:", uploadedFiles);
          console.log("Upload response:", uploadResponse);
          setIsFileUploading(false);
          const fieleObj = uploadResponse[0].uploaded_files.map((file, index) => {
            console.log(`Processing uploaded file ${index}:`, file);
            return {
              file_path: file
            };
          })
          console.log("fieleObj", fieleObj)
          uploadedFiles.forEach((fileGroup, index) => {
            // Use the numeric doc type from fileGroup
            const numericDocType = fileGroup.numericDocType;
            // fileGroup.uploadedPath = uploadResponse[index];
            fileGroup.uploadedPath = {[numericDocType]:fieleObj};
            console.log("fileGroup.uploadedPath set to:", fileGroup.uploadedPath);

            const matchingInput = formInputData.find((input) => input.id === fileGroup.formInputId);
            if (matchingInput) {
              const newValue = [{
                [doc_group]: [fileGroup.uploadedPath],
              }];
              matchingInput.value = newValue;
              console.log(`Updated formInputData for field ${fileGroup.formInputId}:`, matchingInput);

              const matchingProcessedItem = processedData.find(
                (item) => item.name === matchingInput.name
              );
              
              if (matchingProcessedItem) {
                matchingProcessedItem.value = matchingInput.value;
                // const obj = {};
                // Object.values(matchingInput.value[0]).map((item) => {
                //   obj[Object.keys(matchingInput.value[0])[0]] = [{"file_path": item}];
                // })

                console.log(`Updated processedData for field ${matchingInput.name}:`, matchingProcessedItem);
                const payloadPath = findPayloadPath(matchingProcessedItem.name);
                finalValForPayloadpath[payloadPath] = matchingProcessedItem.value;
              }

              if (fileGroup.uploadPath) {
                const pathSegments = fileGroup.uploadPath.split(".");
                let currentNode = processedData;

                pathSegments.forEach((segment, idx) => {
                  if (!currentNode[segment]) {
                    currentNode[segment] = {};
                  }
                  if (idx === pathSegments.length - 1) {
                    currentNode[segment]["uploaded_files_bank"] = [fileGroup.uploadedPath];
                  } else {
                    currentNode = currentNode[segment];
                  }
                });
              } else {
                console.log("No uploadPath specified for file group");
              }
            } else {
              console.log("No matching input found for formInputId:", fileGroup.formInputId);
            }
          });

          processedData.forEach((data) => {
            if (data.name === "uploaded_files" && Array.isArray(data.value)) {
              data.value = data.value.flat();
            }
          });
        } catch (error) {
          console.error("=== FILE UPLOAD ERROR ===");
          console.error("Error during file upload:", error);
          console.error("Error stack:", error.stack);
          setIsFileUploading(false);
        }
      } else {
        console.log("=== NO FILES TO UPLOAD ===");
      }

      // Use convertProcessedDataToObject to get a flat mapping (payload_path -> value)
      const flatData = convertProcessedDataToObject(processedData);

      // Build nested convertedData object from flat mapping
      const convertedData = {};
      Object.entries(flatData).forEach(([path, value]) => {
        const pathParts = path.split('.');
        let currentLevel = convertedData;
        for (let i = 0; i < pathParts.length; i++) {
          const part = pathParts[i];
          if (i === pathParts.length - 1) {
            currentLevel[part] = value;
          } else {
            if (!currentLevel[part]) currentLevel[part] = {};
            currentLevel = currentLevel[part];
          }
        }
      });
      console.log("Final Processed Data:", processedData);
      console.log("Converted Data:", convertedData);
      const in_userid = Number(localStorage.getItem("in_userid"));

      convertedData["add_data_before"] = {};

      if (payloadDataForSW.length) {
        if (payloadDataForSW[0]._id.$oid) {
          convertedData["updated_at"] = Date.now();
          convertedData["updated_by"] = in_userid; // Add updated_by field
        } else {
          convertedData["created_at"] = Date.now();
          convertedData["created_by"] = in_userid; // Add created_by field
        }
      } else if (paramsPayloadData.length) {
        if (paramsPayloadData[0]._id.$oid) {
          convertedData["updated_at"] = Date.now();
          convertedData["updated_by"] = in_userid; // Add updated_by field
        } else {
          convertedData["created_at"] = Date.now();
          convertedData["created_by"] = in_userid; // Add created_by field
        }
      } else {
        if (payload_data.length === 0) {
          if (
            (state &&
              state.payload_config &&
              JSON.parse(state.payload_config) &&
              JSON.parse(state.payload_config).setcreated_at === "1") ||
            (payload_configTwo && payload_configTwo.setcreated_at === "1") ||
            (window.sharedState && window.sharedState.payload_config &&
              JSON.parse(window.sharedState.payload_config) &&
              JSON.parse(window.sharedState.payload_config).setcreated_at === "1")
          ) {
            convertedData["created_at"] = Date.now();
            convertedData["created_by"] = in_userid; // Add created_by field
          }
        } else {
          if (payload_configTwo.setupdated_at === "1") {
            convertedData["updated_at"] = Date.now();
            convertedData["updated_by"] = in_userid; // Add updated_by field
          }
        }
      }

      // Convert status to a number if it exists
      if (convertedData["status"]) {
        convertedData["status"] = Number(convertedData["status"]);
      }
      
      console.log('payload_configTwo', payload_configTwo)
      convertedData["branch_id"] = Number(convertedData["branch_id"])
      
      // Strict priority: Use payload_configTwo first, then fallback to other configurations
      const db_name = (payload_configTwo && payload_configTwo.db_name) 
        ? payload_configTwo.db_name 
        : (paramsPayloadConfig && paramsPayloadConfig.db_name) 
          ? paramsPayloadConfig.db_name 
          : (payloadConfigForSW && payloadConfigForSW.db_name) 
            ? payloadConfigForSW.db_name 
            : "callbacks";
            
      const collection_name = (payload_configTwo && payload_configTwo.collection_name) 
        ? payload_configTwo.collection_name 
        : (paramsPayloadConfig && paramsPayloadConfig.collection_name) 
          ? paramsPayloadConfig.collection_name 
          : (payloadConfigForSW && payloadConfigForSW.collection_name) 
            ? payloadConfigForSW.collection_name 
            : "default";
      
      const objId = paramsPayloadData[0] && paramsPayloadData[0]._id.$oid ? paramsPayloadData[0]._id.$oid : payloadDataForSW[0] && payloadDataForSW[0]._id.$oid ? payloadDataForSW[0]._id.$oid : payload_data.length && payload_data[0]._id.$oid ? payload_data[0]._id.$oid : ""
      if ((payload_data.length && payload_data[0]._id && payload_data[0]._id.$oid) || (paramsPayloadData[0] && paramsPayloadData[0]._id && paramsPayloadData[0]._id.$oid) || (payloadDataForSW[0] && payloadDataForSW[0]._id && payloadDataForSW[0]._id.$oid)) {
        setIsspin(true)
        // Remove the 'household_block_data' key
        delete convertedData.household_block_data;
        delete finalValForPayloadpath.undefined
        Object.values(finalValForPayloadpath).map((item, index) => {
          if(typeof item === 'string' && item.length === 0) {
            delete finalValForPayloadpath[Object.keys(finalValForPayloadpath)[index]]
          } else if(typeof item === 'object' && item.length === 0) {
            delete finalValForPayloadpath[Object.keys(finalValForPayloadpath)[index]]
          }
        })
        Object.keys(finalValForPayloadpath).map((item, index) => {
          // console.log("formInbound", formInbound)
          // console.log("formInbound", finalValForPayloadpath)
          formInbound.map((item2) => {
            if(item === item2.source.BucketField && item2.source && item2.source.add_data_before === "1") {
              finalValForPayloadpath["add_data_before"] = {
                [item2.source.BucketField]: finalValForPayloadpath[item]
              }
              delete finalValForPayloadpath[item]
            }
          })
        })
        
        // Convert product_id and petty_flag to integers in finalValForPayloadpath
        convertFieldsToInt(finalValForPayloadpath);
        
        let responseFromUpdateMongoPayload = await update_mongopayload(
          localStorage.getItem("api_token"),
          db_name,
          collection_name,
          objId,
          {
            // ...convertedData,
            ...finalValForPayloadpath
          },
        );
        if (responseFromUpdateMongoPayload.status == 1) {
          localStorage.setItem('apiSuccess', Date.now());
        }

        if (responseFromUpdateMongoPayload.message) {
          setPopupMessage(responseFromUpdateMongoPayload.message)
          setApiResponseModal(true)
        }
        // if (handlePopupMessage) {
        //   handlePopupMessage("abc");
        // }
        if (closeFormViewModal && typeof closeFormViewModal === 'function') {
          closeFormViewModal(); // Call it when necessary
        }
        // console.log('responseFromUpdateMongoPayload', responseFromUpdateMongoPayload)
        // if (setOnFormviewSubmit && typeof setOnFormviewSubmit === 'function') {
        //   setOnFormviewSubmit(true)
        // }
        console.log("newForm:", setOnFormviewUpdateSubmit);
        // if (setOnFormviewUpdateSubmit && typeof setOnFormviewUpdateSubmit === 'function') {
        // console.log("set true:", setOnFormviewUpdateSubmit);
        //   setOnFormviewUpdateSubmit(true)
        // }
        if (getPayloads && typeof getPayloads === 'function') {
          getPayloads(); // Call it when necessary
        }
        setIsspin(false)
        setIsSubmitting(false)
        return;
      }
      setIsspin(true)
      try {
        // Insert data into MongoDB
        console.log("Starting MongoDB insertion...");
      const autogeneratetxn = payload_config.field_mapping.filter(
        (item) => item.autogeneratetxn === "1"
      );
      if (autogeneratetxn.length > 0) {
        console.log("autogeneratetxn", autogeneratetxn);
        async function gen_id() {
          let txn_ref_no = await generate_dynamic_id(autogeneratetxn, convertedData);
          console.log("txn_ref_no", txn_ref_no);
          return txn_ref_no;
        }
        gen_id().then((txn_ref_no) => {
          console.log("txn_ref_no after gen_id", txn_ref_no);
          autogeneratetxn.forEach((item) => {
          txn_ref_no.forEach((item2) => {
            if(item.BucketField === item2.key[0]) {
              if(item.payloadPathInSelectedForm && item.payloadPathInSelectedForm.length > 0) {
                item.payloadPathInSelectedForm.forEach((path) => {
                  if(path.viewId === payload_config.formview && path.getvalue === 'dynamic') {
                    convertedData[path.payloadpath] = item2.value;
                  }
                });
              }            }
          })
        });
        })
      }
      if (Object.keys(convertedData).includes('branch_id') && (convertedData.branch_id === "" || convertedData.branch_id === null || convertedData.branch_id === undefined || convertedData.branch_id === 0)) {
        convertedData.branch_id = localStorage.getItem("branch_id");
      }
      if (Object.keys(convertedData).includes('user_id') && (convertedData.user_id === "" || convertedData.user_id === null || convertedData.user_id === undefined || convertedData.user_id === 0)) {
        convertedData.user_id = in_userid;
      }
      if (Object.keys(convertedData).includes('updated_at') && (convertedData.updated_at === "" || convertedData.updated_at === null || convertedData.updated_at === undefined || convertedData.updated_at === 0)) {
        convertedData.updated_at = Date.now();
      }
      formData.forEach((item) => {
        if (item.inboundConfig && item.inboundConfig.payloadPathInSelectedForm && item.inboundConfig.payloadPathInSelectedForm.length > 0) {
          item.inboundConfig.payloadPathInSelectedForm.forEach((path) => {
            if(path.viewId === payload_config.formview) {
              if(path.getvalue === 'static') {
                convertedData[path.payloadpath] = path.value;
              }
            }
          });
        }
      });

      // Process arithmetic operations from payload_configTwo
      if (payload_configTwo && payload_configTwo.field_mapping) {
        payload_configTwo.field_mapping.forEach((fieldConfig) => {
          if (fieldConfig.arithmeticOperation === "1") {
            // Find the corresponding form data value using the BucketField dynamically
            const matchingFormData = processedData.find(item => item.name === fieldConfig.BucketField);
            if (matchingFormData && fieldConfig.payloadPathInSelectedForm) {
              fieldConfig.payloadPathInSelectedForm.forEach((pathConfig) => {
                if (pathConfig.viewId === payload_configTwo.formview) {
                  const originalValue = parseFloat(matchingFormData.value) || 0;
                  let calculatedValue = originalValue;
                  
                  // Apply arithmetic operation
                  if (fieldConfig.arithmeticOperator === "*" && fieldConfig.operationValue) {
                    calculatedValue = originalValue * parseFloat(fieldConfig.operationValue);
                  } else if (fieldConfig.arithmeticOperator === "+" && fieldConfig.operationValue) {
                    calculatedValue = originalValue + parseFloat(fieldConfig.operationValue);
                  } else if (fieldConfig.arithmeticOperator === "-" && fieldConfig.operationValue) {
                    calculatedValue = originalValue - parseFloat(fieldConfig.operationValue);
                  } else if (fieldConfig.arithmeticOperator === "/" && fieldConfig.operationValue) {
                    calculatedValue = originalValue / parseFloat(fieldConfig.operationValue);
                  }
                  
                  console.log(`Arithmetic operation on ${fieldConfig.BucketField}: ${originalValue} ${fieldConfig.arithmeticOperator} ${fieldConfig.operationValue} = ${calculatedValue}`);
                  
                  // Set the calculated value to the specified payload path
                  convertedData[pathConfig.payloadpath] = calculatedValue;
                }
              });
            }
          }
        });
      }

      // Convert status to a number if it exists
      if (convertedData["status"]) {
        convertedData["status"] = Number(convertedData["status"]);
      }
      
      // Convert product_id and petty_flag to integers
      convertFieldsToInt(convertedData);
      
      console.log("Converted Data:", convertedData);
      let responseFromInsertMongoPayload;
      setTimeout(async () => {
        responseFromInsertMongoPayload = await insert_mongopayload(
          localStorage.getItem('api_token'),
          db_name,
          collection_name,
          convertedData
        );
        console.log("MongoDB insertion response:", responseFromInsertMongoPayload);
        
        // Stop the spinner
        setIsspin(false);
        setIsSubmitting(false);
        
        // Close the form modal if the function is provided
        if (closeFormViewModal && typeof closeFormViewModal === 'function') {
          closeFormViewModal();
        }

        if (responseFromInsertMongoPayload.message) {
          setPopupMessage(responseFromInsertMongoPayload.message)
          setApiResponseModal(true)
        }
        
        // Check if setOnFormviewSubmit is a function and then call it
        console.log("newForm:", setOnFormviewSubmit);
        if (setOnFormviewSubmit) {
          setOnFormviewSubmit(true);
        } else {
          console.error("setOnFormviewSubmit is undefined or invalid.");
        }
      }, 500)

        console.log("Processed form input values:", processedData);
        console.log("Final converted data object:", convertedData);
      } catch (error) {
        // Handle errors and stop spinner
        setIsspin(false);
        setIsSubmitting(false);
      }
    } else {
      console.log('No form input data available or form is empty.');
    }
  };

  // Converts processed data into an object with payload paths as keys
  const convertProcessedDataToObject = (processedData) => {
    console.log("Input processedData:", processedData);

    const result = {};

    processedData.forEach(item => {
      if (item.payload_path && item.value !== undefined) {
        // Normalize numeric-like strings to numbers
        let value = item.value;
        if (typeof value === 'string' && value !== '' && !isNaN(value)) {
          value = Number(value);
        }

        result[item.payload_path] = value; // value includes the processed checkbox data
        console.log(`Mapping "${item.payload_path}" to "${value}"`);
      }
    });

    // Enforce petty_amount to be negative if present in any path
    Object.keys(result).forEach((key) => {
      const lastSegment = key.split('.').pop();
      if (lastSegment === 'petty_amount' && typeof result[key] === 'number') {
        result[key] = -Math.abs(result[key]);
        console.log(`Enforced negative petty_amount for path ${key}: ${result[key]}`);
      }
      
      // Ensure product_id and petty_flag are always integers
      if (lastSegment === 'product_id' || lastSegment === 'petty_flag') {
        const numValue = parseInt(result[key], 10);
        if (!isNaN(numValue)) {
          result[key] = numValue;
          console.log(`Converted ${lastSegment} to integer for path ${key}: ${result[key]}`);
        }
      }
    });

    return result;
  };

  if (!formData || formData.length === 0) return <div>Loading...</div>;

  return (
    <div className="container mt-5">
      {isspin && (
        <div className="preloader">
          <div className="loader" ng-hide="data.length > 0"></div>
        </div>
      )}
      {isFileUploading && (
        <div className="file-upload-loader">
          <div className="loader"></div>
        </div>
      )}
      <div className="row mb-4">
        <div className="col">
          <ReactFormGenerator
            key={resetKey}
            download_path=""
            back_action="/"
            answer_data={{}}
            form_action="/api/form"
            form_method="POST"
            data={formData}
            locale="en"
            onChange={handleInputChange}
            onBlur={() => {
              formData.forEach((field) => {
                if (field.inboundConfig && field.inboundConfig.alert_condition) {
                  checkifalert(field);
                }
              });
            }}
            payload_data={paramsPayloadData.length ? paramsPayloadData : payloadDataForSW.length ? payloadDataForSW : Array.isArray(payload_data) ? payload_data : [payload_data]}
            payload_path={formData.map(field => field.payloadpath).flat()}
            dropdownOptions={dropdownOptions}
          />
          <SubmitButton
            onSave={handleSave}
            text="Submit Form"
            disabled={process_err || isSubmitting}
          />
        </div>
      </div>
      <Modal
        open={apiResponseModal}
        onCancel={() => {
          setApiResponseModal(false);
          setResetKey(prev => prev + 1);
          setFormInputData([]);
          setUpdatedFields({});
          setIsSubmitting(false);
          window.close();
        }}
        width="auto"
        footer={null}
      >
        <p>{popupMessage}</p>
      </Modal>
    </div>
  );
};

export default withRouter(FormBuildView);
